import { createFileRoute } from '@tanstack/react-router';
import { LoginPage } from '@/features/auth/auth-pages';

export const Route = createFileRoute('/invite')({
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({ token: typeof s.token === 'string' ? s.token : undefined }),
  component: function Invite() {
    const { token } = Route.useSearch();
    return <LoginPage initialTab="invite" token={token} />;
  },
});
